import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_game_wrapper = _resolveComponent("game-wrapper")!

  return (_openBlock(), _createBlock(_component_game_wrapper, {
    title: "Quick Tapper",
    name: "QuickTapper",
    "is-game-over": _ctx.isGameOver,
    counter: _ctx.restartCounter,
    "score-time": _ctx.scoreTime,
    "action-buttons": _ctx.actionButtons,
    instruction: _ctx.currentInstruction,
    onTap: _ctx.tapped,
    onPrecountdownOver: _ctx.start,
    onRestart: _ctx.restart
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["square--large", _ctx.currentColorClass])
      }, null, 2)
    ]),
    _: 1
  }, 8, ["is-game-over", "counter", "score-time", "action-buttons", "instruction", "onTap", "onPrecountdownOver", "onRestart"]))
}